import { gql } from '@apollo/client';

export const UPDATE_ACTIVE_LICENSE = gql`
  mutation UpdateActiveLicense($id: String!, $input: UpdateActiveLicenseInput!) {
    updateActiveLicense(id: $id, input: $input) {
      success
      message
      error
    }
  }
`;
